module.exports = __webpack_public_path__ + "img/team-solid.c1342513.svg";